import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import SEO from "@/components/SEO";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PopularDestinations from "@/components/PopularDestinations";
import PopularRoutes from "@/components/PopularRoutes";
import Services from "@/components/Services";
import Fleet from "@/components/Fleet";
import Testimonials from "@/components/Testimonials";
import Coverage from "@/components/Coverage";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminDashboard from "@/pages/AdminDashboard";
import PricingConfig from "@/pages/PricingConfig";

function HomePage() {
  return (
    <>
      <SEO />
      <Header />
      <Hero />
      <PopularDestinations />
      <PopularRoutes />
      <Services />
      <Fleet />
      <Testimonials />
      <Coverage />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="App bg-black">
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/pricing" element={<PricingConfig />} />
            </Routes>
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
